import { Grid } from "@material-ui/core";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { getCurrentStaff, isAdmin } from "app/common/LocalFunction";
import { renderOptionsStaff } from "app/PatientManagement/ReportRevenueDetail/ReportRevenueDetailSearch";
import { pagingClientAwardType } from "app/services/ClientAwardType";
import { pagingStaff } from "app/services/StaffService";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo } from "react";
import { filterStaffOptions } from "utils";
import * as Yup from "yup";
import { ImageFileComponent } from "../Component/LoyaltyPointForm";

function LoyaltyPointsPopup({
  open,
  handleClose,
  handleSubmit,
  handleAfterSubmit,
  initialValues,
  patient,
}) {
  const currentStaff = getCurrentStaff();

  const validationSchema = Yup.object().shape({
    pointAmount: Yup.number()
      .required("Vui lòng nhập điểm")
      .typeError("Điểm phải là số")
      .max(100000, "Điểm không được vượt quá 100.000")
      .nullable(),

    clientAwardType: Yup.object()
      .nullable()
      .required("Chưa chọn hạng mục tích điểm!"),
  });
  return (
    <PopupForm
      size="md"
      title="Hạng tích điểm"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: {
          patient,
          pointAccumulator: currentStaff,
          ...initialValues,
          validationSchema: validationSchema,
        },
        onSubmit: async (values, { setSubmitting }) => {
          handleSubmit(values, { setSubmitting });
          if (handleAfterSubmit) {
            handleAfterSubmit();
          }
        },
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValuesForm />
          </>
        );
      }}
    </PopupForm>
  );
}

const ValuesForm = observer(() => {
  const { setFieldValue, values } = useFormikContext();
  const isAdminRole = isAdmin();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} md={3}>
        <GlobitsDateTimePicker
          label={"Thời gian tích điểm"}
          name={"pointAccumulationTime"}
          isDateTimePicker
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <GlobitsPagingAutocomplete
          name={"pointAccumulator"}
          label={"Người tạo"}
          api={pagingStaff}
          displayLabel={"staffName"}
          ListboxComponent={forwardRef((props, ref) => {
            const { children, ...other } = props;
            return (
              <ul {...other} ref={ref}>
                <ol>
                  <li>{children}</li>
                </ol>
              </ul>
            );
          })}
          renderOption={(option) => renderOptionsStaff(option)}
          filterOptions={filterStaffOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6}>
        <GlobitsPagingAutocomplete
          name={"clientAwardType"}
          label={"Hạng mục tích điểm"}
          api={pagingClientAwardType}
          onChange={(_, value) => {
            setFieldValue("clientAwardType", value);
            setFieldValue(
              "pointAmount",
              value?.awardPoint * (values?.quantity || 0)
            );
          }}
          ListboxComponent={forwardRef((props, ref) => {
            const { children, ...other } = props;
            return (
              <ul {...other} ref={ref}>
                <ol>
                  <li>{children}</li>
                </ol>
              </ul>
            );
          })}
          renderOption={(option) => renderOptionsClientAwardType(option)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <GlobitsNumberInput
          label={"Số lượng"}
          name={"quantity"}
          onChange={(e) => {
            const quantity = +e.target.value;
            setFieldValue("quantity", quantity);
            setFieldValue(
              "pointAmount",
              values?.clientAwardType?.awardPoint * quantity
            );
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <GlobitsNumberInput
          label={"Điểm"}
          name={"pointAmount"}
          disabled={!isAdminRole}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <GlobitsTextField label={"Ghi chú"} name={"note"} isTextArea row={3} />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <ImageFileComponent />
      </Grid>
    </Grid>
  );
});

export const renderOptionsClientAwardType = (option) => {
  const name = option?.name || "Không có tên";
  const code = option?.code;
  const awardPoint = option?.awardPoint;

  return (
    <div className="award-option">
      <span className="award-title">{name}</span>
      <span className="award-meta">
        Mã: <b>{code}</b> <span className="point">+{awardPoint} điểm/lượt</span>
      </span>
    </div>
  );
};

export default memo(observer(LoyaltyPointsPopup));
